export default "__VITE_ASSET__Dqv22$yG__"